// Mapping or helper for case study placeholder images based on the slug/name

const CUSTOM_IMAGES_MAP: Record<string, string[]> = {
  // If you ever want to manually specify files or do something completely custom, you can put it here:
  // 'custom-case': [ '/images/placeholders/cases/case-1.webp', '/images/placeholders/cases/case-2.webp' ]
}

/**
 * Returns an array of placeholder image paths for a given case study slug.
 * If the slug is not provided or not mapped, it defaults to 'latin-dance-passion' images.
 */
const getPlaceholderImages = (slug?: string): string[] => {
  if (!slug) {
    // Return a default fallback if slug is missing
    return Array.from({ length: 9 }, (_, i) => `/images/placeholders/latin-dance-passion/latin-dance-passion-${i + 1}.webp`)
  }

  // Normalize slug to extract the folder/file name prefix (e.g. "/latin-dance-passion" -> "latin-dance-passion")
  const cleanSlug = slug.replace(/^\//, '')

  if (CUSTOM_IMAGES_MAP[cleanSlug]) {
    return CUSTOM_IMAGES_MAP[cleanSlug]
  }

  // Define count of images available for known slugs
  const imageCounts: Record<string, number> = {
    'latin-dance-passion': 11,
    // Add other case study slugs here with their counts if they differ (default is 9)
  }

  const count = imageCounts[cleanSlug] || 9
  return Array.from({ length: count }, (_, i) => `/images/placeholders/${cleanSlug}/${cleanSlug}-${i + 1}.webp`)
}

export default getPlaceholderImages

